import api from './api';

const reportApprovalService = {
  // Query pending / approval queue with filters
  getApprovalQueue: async (filter = {}) => {
    const response = await api.get('/report-approval/queue', { params: filter });
    return response.data;
  },

  // KPI summary counters (Pending, Critical, Held, Released Today, Amended)
  getQueueSummary: async (centreId = null) => {
    const params = centreId ? { centreId } : {};
    const response = await api.get('/report-approval/summary', { params });
    return response.data;
  },

  // Fetch full clinical review data: patient demographics, observations, delta checks, critical alerts
  getReviewDetail: async (testId) => {
    const response = await api.get(`/report-approval/${testId}/review`);
    return response.data;
  },

  // Approve and release report under reporting doctor authority
  releaseReport: async (testId, payload) => {
    const response = await api.post(`/report-approval/${testId}/release`, payload);
    return response.data;
  },

  // Place report on clinical hold
  holdReport: async (testId, reason) => {
    const response = await api.post(`/report-approval/${testId}/hold`, { reason });
    return response.data;
  },

  // Remove report from clinical hold
  unholdReport: async (testId) => {
    const response = await api.post(`/report-approval/${testId}/unhold`);
    return response.data;
  },

  // Request amendment on locked / released report
  amendReport: async (testId, payload) => {
    const response = await api.post(`/report-approval/${testId}/amend`, payload);
    return response.data;
  },

  // Retrieve complete release audit trail for report
  getAuditTrail: async (testId) => {
    const response = await api.get(`/report-approval/${testId}/audit-trail`);
    return response.data;
  }
};

export default reportApprovalService;
